import "antd/lib/date-picker/style/css";
import { inject, observer } from "mobx-react";
import queryString from "query-string";
import React from "react";
import WalletService from "../../core/services/wallet";
import AppStore from "../../Store";
import QuestionPage from "../question/question";

@inject("appStore")
@observer
export default class WalletSuccessPage extends React.Component<{
  appStore: AppStore;
  location: Location;
}> {
  public static url: string = "/wallet-success";
  private walletService: WalletService = new WalletService();

  componentDidMount() {
    const queryParams: any = queryString.parse(this.props.location.search);
    const transactionId: string = queryParams["transactionId"]
      ? queryParams["transactionId"]
      : queryParams["?transactionId"];
    const receipt: string = queryParams["receipt"];

    if (transactionId) {
      this.walletPaymentSuccess(transactionId, receipt);
    }
  }

  walletPaymentSuccess = async (transactionId: string, receipt: string) => {
    try {
      this.props.appStore.isOfferAccepting = true;
      // const paymentResponse = await this.walletService.walletPaymentSuccess(transactionId, receipt, this.props.appStore.answerId);
      const paymentResponse = await this.walletService.walletPaymentSuccess(
        this.props.appStore.answerId
      );

      this.props.appStore.chosenAnswerIndex = paymentResponse.chosenAnswerIndex;
      setTimeout(() => {
        this.props.appStore.correctAnswerIndex =
          paymentResponse.correctAnswerIndex;

        setTimeout(() => {
          if (paymentResponse.isStampFull) {
            if (paymentResponse.isCorrect) {
              this.props.appStore.isUserWinThreeStampModalVisible = true;
            } else {
              this.props.appStore.isUserAnsweredWrongThirdQuestionModalVisible =
                true;
            }
          } else {
            if (paymentResponse.isCorrect) {
              this.props.appStore.is1GBWinModalVisible = true;
            } else {
              this.props.appStore.is500MBModalVisible = true;
            }
          }
          this.props.appStore.answerId = undefined;
          this.props.appStore.questionId = undefined;
          this.props.appStore.isOfferAccepting = false;
        }, 3000);
      }, 2000);
    } catch (error) {
      this.props.appStore.handleUnknownErrorModalVisibility(true);
      console.error(error);
    }
  };

  render() {
    return (
      <QuestionPage
        appStore={this.props.appStore}
        location={this.props.location}
      ></QuestionPage>
    );
  }
}
